(() => {
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const escapeHtml = value => String(value).replace(/[&<>'"]/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);

  const enableDragRail = (rail, ignoreSelector = '') => {
    if (!rail || !matchMedia('(pointer:fine)').matches) return;
    let drag = null;
    let suppressClick = false;
    rail.addEventListener('pointerdown', event => {
      if (event.button !== 0 || (ignoreSelector && event.target.closest(ignoreSelector))) return;
      drag = { id: event.pointerId, x: event.clientX, left: rail.scrollLeft };
      suppressClick = false;
      rail.setPointerCapture(event.pointerId);
      rail.classList.add('is-dragging');
    });
    rail.addEventListener('pointermove', event => {
      if (!drag || drag.id !== event.pointerId) return;
      const distance = event.clientX - drag.x;
      if (Math.abs(distance) > 6) suppressClick = true;
      rail.scrollLeft = drag.left - distance * 1.08;
    });
    const finish = event => {
      if (!drag || drag.id !== event.pointerId) return;
      rail.classList.remove('is-dragging');
      if (rail.hasPointerCapture(event.pointerId)) rail.releasePointerCapture(event.pointerId);
      drag = null;
    };
    rail.addEventListener('pointerup', finish);
    rail.addEventListener('pointercancel', finish);
    rail.addEventListener('click', event => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      suppressClick = false;
    }, true);
  };

  $$('[data-cg-qty]').forEach(group => {
    const input = $('input[type="number"]', group);
    if (!input) return;
    $$('button', group).forEach(button => button.addEventListener('click', () => {
      const step = Number(input.step) || 1;
      const min = Number(input.min) || 0;
      const next = Number(input.value || 0) + (button.dataset.cgQtyAction === 'increase' ? step : -step);
      input.value = String(Math.max(min, next));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
  });

  $$('[data-cg-sort]').forEach(select => select.addEventListener('change', () => select.form?.submit()));

  $$('[data-cg-product]').forEach(root => {
    const select = $('[data-cg-variant-select]', root);
    const image = $('[data-cg-product-image]', root);
    const price = $('[data-cg-product-price]', root);
    const add = $('[data-cg-add]', root);
    const index = $('.cg-system-product__index', root);
    const thumbs = $$('[data-cg-variant-thumb]', root);
    const galleryThumbs = $$('[data-cg-gallery-thumb]', root);
    const thumbRail = $('.cg-system-product__thumbs', root);

    const showGalleryImage = button => {
      if (!button || !image) return;
      image.src = button.dataset.cgThumb;
      image.srcset = '';
      galleryThumbs.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      if (index) {
        const position = galleryThumbs.indexOf(button) + 1;
        index.textContent = `${String(position).padStart(2, '0')} / ${String(galleryThumbs.length).padStart(2, '0')}`;
      }
      thumbRail?.scrollTo({ left: button.offsetLeft - (thumbRail.clientWidth - button.clientWidth) / 2, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };

    const sync = () => {
      const option = select?.selectedOptions[0];
      if (!option) return;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (add) {
        const available = option.dataset.available === 'true';
        add.disabled = !available;
        add.innerHTML = available ? 'Add to cart <span>+</span>' : 'Sold out';
      }
      if (image && option.dataset.image) {
        image.src = option.dataset.image;
        image.srcset = '';
        image.alt = `${image.alt.split(' — ')[0]} — ${option.textContent.split(' — ')[0].trim()}`;
      }
      const activeThumb = thumbs.find(button => button.dataset.variantId === option.value);
      if (activeThumb) showGalleryImage(activeThumb);
    };

    select?.addEventListener('change', sync);
    sync();

    galleryThumbs.forEach(button => button.addEventListener('click', () => {
      if (button.dataset.variantId && select) {
        select.value = button.dataset.variantId;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      showGalleryImage(button);
    }));

    const cycleGallery = direction => {
      if (!galleryThumbs.length) return;
      const active = galleryThumbs.findIndex(button => button.getAttribute('aria-pressed') === 'true');
      const next = (Math.max(active, 0) + direction + galleryThumbs.length) % galleryThumbs.length;
      const button = galleryThumbs[next];
      if (button.dataset.variantId && select) {
        select.value = button.dataset.variantId;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      } else showGalleryImage(button);
    };
    $('[data-cg-gallery-previous]', root)?.addEventListener('click', () => cycleGallery(-1));
    $('[data-cg-gallery-next]', root)?.addEventListener('click', () => cycleGallery(1));
  });

  $$('[data-cg-product-reviews-section]').forEach(section => {
    const rail = $('[data-product-reviews]', section);
    const renderReview = review => `<article><div class="review-stars" aria-label="5 out of 5 stars">★★★★★</div><strong>${escapeHtml(review.title || 'Review')}</strong><details><summary>Read full review</summary><blockquote>“${escapeHtml(review.quote)}”</blockquote></details><p><strong>${escapeHtml(review.author)}</strong><span>Customer</span></p></article>`;
    fetch(section.dataset.reviewsUrl, { headers: { Accept: 'application/json' } })
      .then(response => {
        if (!response.ok) throw new Error('Review request failed');
        return response.json();
      })
      .then(reviews => {
        rail.innerHTML = (reviews[section.dataset.productKey] || []).map(renderReview).join('');
        enableDragRail(rail, 'a,button,summary');
      })
      .catch(() => {
        rail.innerHTML = '<p>Judge.me reviews are temporarily unavailable.</p>';
      });
  });

  $$('[data-cg-address-delete]').forEach(button => button.addEventListener('click', event => {
    if (!confirm('Remove this address?')) event.preventDefault();
  }));

  const challenge = $('.shopify-challenge__container');
  if (challenge) challenge.classList.add('cg-system-challenge');
})();
